import Markdown from '../../components/markdown';
import type { ChatAttachment } from '../../lib/chat-api';
import { AttachmentList } from './attachment-list';

/* A chat message bubble. User turns are compact right-aligned bubbles; Naïa's */
/* replies read like a document (full width, Markdown). Extracted verbatim from */
/* Chat.tsx (decomposition, Phase 4). */
export function Bubble({
  role,
  text,
  attachments,
}: {
  role: 'user' | 'assistant';
  text: string;
  attachments?: ChatAttachment[] | null;
}) {
  const isUser = role === 'user';
  return (
    <div className={isUser
      ? "self-end max-w-[min(70%,560px)] bg-[color-mix(in_srgb,var(--naia-blue)_10%,transparent)] border border-[color-mix(in_srgb,var(--naia-blue)_20%,transparent)] rounded-card p-[11px_14px] shadow-card text-[15px] leading-[1.45] text-foreground whitespace-pre-wrap break-words flex flex-col gap-2"
      : "self-stretch max-w-full bg-naia-card-alt border border-border rounded-card p-[14px_18px] text-[15.5px] leading-[1.6] text-foreground whitespace-pre-wrap break-words flex flex-col gap-2"
    }>
      <AttachmentList attachments={attachments} />
      {text && (isUser ? <div>{text}</div> : <Markdown text={text} />)}
    </div>
  );
}
